import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const QuestionSvg = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9997 20.1666C5.93706 20.1666 1.83301 16.0625 1.83301 10.9999C1.83301 5.93731 5.93706 1.83325 10.9997 1.83325C16.0622 1.83325 20.1663 5.93731
       20.1663 10.9999C20.1663 16.0625 16.0622 20.1666 10.9997 20.1666ZM10.9997 18.3333C15.0498 18.3333 18.333 15.05 18.333 10.9999C18.333 6.94983 15.0498
        3.66659 10.9997 3.66659C6.94958 3.66659 3.66634 6.94983 3.66634 10.9999C3.66634 15.05 6.94958 18.3333 10.9997 18.3333ZM10.083
         13.7499H11.9163V15.5833H10.083V13.7499ZM11.9163 12.2421V12.8333H10.083V11.4583C10.083 10.952 10.4934 10.5416 10.9997 10.5416C11.759
          10.5416 12.3747 9.92595 12.3747 9.16658C12.3747 8.40719 11.759 7.79159 10.9997 7.79159C10.3326 7.79159 9.77647 8.26663 9.65107
           8.89687L7.85304 8.53726C8.14551 7.06668 9.44317 5.95825 10.9997 5.95825C12.7716 5.95825 14.208 7.39467 14.208 9.16658C14.208
            10.62 13.2416 11.8477 11.9163 12.2421Z"
      fill="currentColor"
    />
  </svg>
);

const Question = (props: IIconProps) => <Icon component={QuestionSvg} {...props} />;

export default Question;
